<template>

<app-table-cell class="timeline" :data-theme="theme">
 
    <div class="timeline-segment" v-for="segment in segments" :key="segment.time" :class="{'is-start': segment.start, 'is-middle': segment.middle, 'is-end': segment.end}">

        <div class="timeline-segment-selected" v-if="selected" />

    </div>
    
</app-table-cell>
    
</template>
    
<script>
    
export default {
    
    props: ['start', 'end', 'min', 'max', 'times', 'selected', 'theme'],

    computed: {
    
        segments: function() {

            var segments = []

            this.$_.each(this.times, function(time, value) {

                value = parseInt(value)

                if (value >= this.min && value <= this.max) {

                    segments.push({
                        time: value,
                        start: value === this.start,
                        end: value === this.end,
                        middle: value > this.start && value < this.end
                    })
                    
                }


            }.bind(this))

            return segments
        
        }
    
    }
    
}
    
</script>
    
<style scoped>
    
.timeline {
    display: grid;
    flex-direction: row;
    height: 100%;
    padding: 0px!important;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    grid-template-rows: 1fr;
	align-items: initial!important;
}

.timeline-segment {
}

.timeline-segment:before {
    content: '';
    display: block;
    width: 2px;
    position: absolute;
    left: 50%;
    margin-left: -1px;
    top: 0px;
    height: 100%;
    z-index: 12;
    background-color: rgba(0, 0, 0, 0.02);
    z-index: 1;
}

.timeline-segment.is-start:after,
.timeline-segment.is-middle:after,
.timeline-segment.is-end:after {
    background-color: #4faa80;
}

.timeline[data-theme="red"] .timeline-segment.is-start:after,
.timeline[data-theme="red"] .timeline-segment.is-middle:after,
.timeline[data-theme="red"] .timeline-segment.is-end:after {
    background-color: #c55b5b;
}

.timeline-segment.is-start:after,
.timeline-segment.is-end:after {
    content: '';
    display: block;
    position: absolute;
    width: 50%;
    height: 100%;
    left: 50%;
    top: 0%;
    z-index: 2;
}

.timeline-segment.is-end:after {
    left: 0px;
}

.timeline-segment.is-middle:after {
    content: '';
    display: block;
    position: absolute;
    width: 200%;
    height: 100%;
    left: -50%;
    top: 0%;
    z-index: 2;
}

.timeline-segment.is-middle:before {
    background-color: rgba(255, 255, 255, 0.25);
    z-index: 4;
}

.timeline-segment-selected {
    background-color: #bafcaf;
    z-index: 2;
    top: 50%;
    left: 50%;
}

.timeline-segment.is-start .timeline-segment-selected,
.timeline-segment.is-end .timeline-segment-selected {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-left: -10px;
    margin-top: -10px;
    z-index: 3;
}

.timeline-segment.is-middle .timeline-segment-selected {
    width: 200%;
    height: 2px;
    left: -50%;
    margin-top: -1px;
    z-index: 3;
}
    
</style>